(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("aVDGX", function(module, exports) {

$parcel$export(module.exports, "useSorts", function () { return $7f4e044063b87990$export$20f7d632032821c3; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $l7I7e = parcelRequire("l7I7e");

var $kxLPc = parcelRequire("kxLPc");
function $7f4e044063b87990$export$20f7d632032821c3(appliedSort, categoryDefaultSort, availableSorts, connection) {
    var connectionDefaultSort = $2whNH.map(connection, function(connection) {
        return connection.sortBy;
    });
    var replaceDefaultWith = $2whNH.flatMap(categoryDefaultSort, function(defaultSortOrder) {
        if ($7bjme.equal(connectionDefaultSort, /* Default */ 0) && $2whNH.mapWithDefault(availableSorts, false, function(sorts) {
            return sorts.includes(defaultSortOrder);
        })) return defaultSortOrder;
    });
    var availableSorts$1 = $2whNH.map(availableSorts, function(sorts) {
        return $i7mYY.keepMap(sorts, function(sort) {
            if ($7bjme.equal(sort, replaceDefaultWith)) return;
            else if (sort === /* Default */ 0 && $2whNH.isSome(replaceDefaultWith)) return $2whNH.flatMap(replaceDefaultWith, function(sub) {
                return [
                    $kxLPc.humanizeSort(sub),
                    /* Default */ 0
                ];
            });
            else return [
                $kxLPc.humanizeSort(sort),
                sort
            ];
        });
    });
    var effectiveSort = appliedSort !== undefined ? appliedSort : connectionDefaultSort !== undefined ? connectionDefaultSort : categoryDefaultSort !== undefined ? categoryDefaultSort : undefined;
    var availableSorts$2 = $l7I7e.use(availableSorts$1);
    var effectiveSort$1 = $l7I7e.use(effectiveSort);
    return [
        effectiveSort$1,
        $2whNH.getWithDefault(availableSorts$2, [])
    ];
}
 /* Persistence-Showside Not a pure module */ 
});
parcelRegister("kxLPc", function(module, exports) {

$parcel$export(module.exports, "humanizeSort", function () { return $ef4bfcbd337df314$export$4ba5ee7ea29546ce; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $ef4bfcbd337df314$export$4ba5ee7ea29546ce(sort) {
    switch(sort){
        case /* Default */ 0:
            return "Default";
        case /* Featured */ 1:
            return "Featured";
        case /* BestSellers */ 2:
            return "Best Sellers";
        case /* Newest */ 3:
            return "New Arrivals";
        case /* HighestPrice */ 4:
            return "Price: High-Low";
        case /* LowestPrice */ 5:
            return "Price: Low-High";
        case /* HighestDiscount */ 6:
            return "Highest Discount";
    }
}
 /* No side effect */ 
});


parcelRegister("ceMif", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $8e8c40e1392ba0b9$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $fEMeF = parcelRequire("fEMeF");

var $c6E1z = parcelRequire("c6E1z");

var $7wIsS = parcelRequire("7wIsS");

var $1xf0g = parcelRequire("1xf0g");

var $insiF = parcelRequire("insiF");

var $gCzsf = parcelRequire("gCzsf");

var $dC2cV = parcelRequire("dC2cV");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
function $8e8c40e1392ba0b9$var$FiltersBadges$Badge(Props) {
    var disabled = Props.disabled;
    var facet = Props.facet;
    var label = Props.label;
    var onClick = Props.onClick;
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "filters-badge",
        dataId: facet,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            "aria-label": "unselect filter: " + label,
            className: $ezf3v.prefix($1TRFX.make([
                "inline-flex space-x-2 p-2 relative items-center justify-center cursor-pointer dark-hover darker-active bg-main hover:text-primary text-secondary",
                disabled ? "opacity-50 pointer-events-none" : ""
            ])),
            role: "button",
            onClick: onClick
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("bg-primary opacity-5 absolute inset-0 rounded")
        }), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-grow relative whitespace-nowrap font-medium")
        }, label), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("relative")
        }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {
            size: /* Px */ {
                _0: 20
            }
        })))
    });
}
$8e8c40e1392ba0b9$var$FiltersBadges$Badge.displayName = "FiltersBadges.Badge";
var $8e8c40e1392ba0b9$export$37acb3580601e69a = {
    make: $8e8c40e1392ba0b9$var$FiltersBadges$Badge
};
function $8e8c40e1392ba0b9$var$FiltersBadges(Props) {
    var connection = Props.connection;
    var appliedFilters = Props.appliedFilters;
    var appliedSort = Props.appliedSort;
    var paddingOpt = Props.padding;
    var disableAllOpt = Props.disableAll;
    var padding = paddingOpt !== undefined ? paddingOpt : true;
    var disableAll = disableAllOpt !== undefined ? disableAllOpt : false;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var defaultFilters = $2whNH.flatMap(connection, function(connection) {
        return $1xf0g.ExternalConnection.getFilterBy(connection, config.transitiveAccount);
    });
    $hBcYV.useRouter(undefined);
    var match$1 = $9pMGg.use(undefined);
    var onChangeFilters = match$1.onChangeFilters;
    var match$2 = $aSJcu.use(undefined);
    var isMobile = match$2.isMobile;
    var filtersConfig = $2whNH.flatMap(config.transitiveAccount, function(account) {
        return account.filtersConfig2;
    });
    var paddingNum = padding ? isMobile ? 12 : 24 : 0;
    $c6E1z.useCategoryProducts(config.transitiveStoreId, undefined, connection, config.settings.hideOutOfStock, appliedFilters, defaultFilters, undefined, appliedSort, true, match$1.smartnavApiHost, match$1.market, undefined);
    var handleRemove = function handleRemove(facet) {
        if (appliedFilters !== undefined) return $iv6Yc._1(onChangeFilters, {
            entries: $i7mYY.keep(appliedFilters.entries, function(param) {
                return param.facet !== facet;
            }),
            minPrice: $2whNH.keep(appliedFilters.minPrice, function(minPrice) {
                return $fEMeF.toMinPriceFacet(minPrice) !== facet;
            }),
            maxPrice: $2whNH.keep(appliedFilters.maxPrice, function(maxPrice) {
                return $fEMeF.toMaxPriceFacet(maxPrice) !== facet;
            })
        });
    };
    var items = appliedFilters !== undefined ? filtersConfig !== undefined ? $i7mYY.concat($i7mYY.concat($i7mYY.map(appliedFilters.entries, function(param) {
        var facet = param.facet;
        return /*#__PURE__*/ $g85JO.createElement($8e8c40e1392ba0b9$var$FiltersBadges$Badge, {
            disabled: disableAll,
            facet: facet,
            label: $2whNH.getWithDefault($dC2cV.getLabelByFacet(filtersConfig, facet), facet),
            onClick: function onClick(param) {
                handleRemove(facet);
            },
            key: facet
        });
    }), $2whNH.mapWithDefault(appliedFilters.minPrice, [], function(minPrice) {
        var facet = $fEMeF.toMinPriceFacet(minPrice);
        var label = "Min Price: " + minPrice.toString();
        return [
            /*#__PURE__*/ $g85JO.createElement($8e8c40e1392ba0b9$var$FiltersBadges$Badge, {
                disabled: disableAll,
                facet: facet,
                label: label,
                onClick: function onClick(param) {
                    handleRemove(facet);
                },
                key: facet
            })
        ];
    })), $2whNH.mapWithDefault(appliedFilters.maxPrice, [], function(maxPrice) {
        var facet = $fEMeF.toMaxPriceFacet(maxPrice);
        var label = "Max Price: " + maxPrice.toString();
        return [
            /*#__PURE__*/ $g85JO.createElement($8e8c40e1392ba0b9$var$FiltersBadges$Badge, {
                disabled: disableAll,
                facet: facet,
                label: label,
                onClick: function onClick(param) {
                    handleRemove(facet);
                },
                key: facet
            })
        ];
    })) : [] : [];
    if (appliedFilters === undefined) return null;
    var i = items.length;
    var items$1 = !isMobile && i > 1 ? $i7mYY.concat(items, [
        /*#__PURE__*/ $g85JO.createElement($tUpyX.make, {
            children: "Clear All Filters",
            unstyled: true,
            className: $ezf3v.prefix("flex items-center h-11 text-base no-underline hover:underline text-tertiary cursor-pointer"),
            role: "button",
            ariaLabel: "clear all filters",
            dataTestId: "filters-clear-all-badge",
            onClick: function onClick(param) {
                $iv6Yc._1(onChangeFilters, undefined);
            }
        })
    ]) : items;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        "aria-label": "applied filters",
        className: $1TRFX.make([
            "swiper-small-navigation",
            isMobile ? "" : "swiper-desktop",
            paddingNum !== 0 ? $ezf3v.prefix("py-2") : "",
            $ezf3v.prefix("flex-grow overflow-hidden")
        ]),
        role: "group"
    }, /*#__PURE__*/ $g85JO.createElement($insiF.make, {
        items: items$1,
        spaceBetween: 12,
        slidesOffsetBefore: paddingNum,
        slidesOffsetAfter: paddingNum,
        enableFreeMode: true,
        enableNavigation: true,
        enableMousewheel: true,
        className: $ezf3v.prefix("w-full"),
        restorationId: "smartnav-applied-filters"
    }));
}
$8e8c40e1392ba0b9$var$FiltersBadges.displayName = "FiltersBadges";
var $8e8c40e1392ba0b9$export$dd44f18ab656f3bb = $8e8c40e1392ba0b9$var$FiltersBadges;
 /* react Not a pure module */ 
});

parcelRegister("2QKwI", function(module, exports) {

$parcel$export(module.exports, "makeFromConfig", function () { return $213487552e463abb$export$b11858455b8e7f87; });
$parcel$export(module.exports, "make", function () { return $213487552e463abb$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $3tOK1 = parcelRequire("3tOK1");

var $7wIsS = parcelRequire("7wIsS");

var $27XcH = parcelRequire("27XcH");

var $021DA = parcelRequire("021DA");

var $gCzsf = parcelRequire("gCzsf");

var $dC2cV = parcelRequire("dC2cV");
function $213487552e463abb$export$b11858455b8e7f87(includeCountZeroOpt, countMap, appliedFilters, allSections, section) {
    var includeCountZero = includeCountZeroOpt !== undefined ? includeCountZeroOpt : false;
    var getValue = $3tOK1.memWithCacheKey(function(facet) {
        return $2whNH.mapWithDefault(appliedFilters, false, function(facets) {
            return $i7mYY.some(facets.entries, function(param) {
                return param.facet === facet;
            });
        });
    }, function(facet) {
        return [
            facet,
            appliedFilters
        ];
    });
    var getIndex = $3tOK1.mem(function(facet) {
        var currentSectionIndex = $i7mYY.getIndexBy(allSections, function(s) {
            return $dC2cV.Section.getId(s) === $dC2cV.Section.getId(section);
        });
        if (currentSectionIndex !== undefined) return $i7mYY.reduce($i7mYY.slice(allSections, 0, currentSectionIndex + 1 | 0), 0, function(acc, currentSection) {
            if ($dC2cV.Section.getId(currentSection) !== $dC2cV.Section.getId(section)) return acc + $dC2cV.Section.getOptions(currentSection).length | 0;
            else return acc + $2whNH.getWithDefault($i7mYY.getIndexBy($dC2cV.Section.getOptions(currentSection), function(option) {
                return option.facet === facet;
            }), 0) | 0;
        });
        else return 0;
    });
    var getCount = $3tOK1.memWithCacheKey(function(facet) {
        return $2whNH.getWithDefault($d3YYW.get($d3YYW.fromArray($i7mYY.keep(countMap, function(param) {
            return param[1] > 0;
        })), facet), 0);
    }, function(facet) {
        return [
            facet,
            countMap
        ];
    });
    var options = $i7mYY.map($i7mYY.keepMap($dC2cV.Section.getOptions(section), function(option) {
        var count = $iv6Yc._1(getCount, option.facet);
        var value = $iv6Yc._1(getValue, option.facet);
        var index = $iv6Yc._1(getIndex, option.facet);
        var disabled = count === 0 && !value;
        if (count > 0 || includeCountZero) return [
            option,
            count,
            value,
            index,
            disabled
        ];
    }), function(param) {
        var option = param[0];
        return {
            id: option.id,
            index: param[3],
            facet: option.facet,
            label: option.label,
            swatch: option.value,
            value: param[2],
            count: param[1],
            disabled: param[4]
        };
    });
    var label = $dC2cV.Section.getLabel(section);
    var id = $dC2cV.Section.getId(section);
    var style;
    switch(section.TAG | 0){
        case /* ColorCheckbox */ 0:
            style = /* ColorCheckbox */ 0;
            break;
        case /* ImageCheckbox */ 1:
            style = /* ImageCheckbox */ 2;
            break;
        case /* Checkbox */ 2:
            style = /* Checkbox */ 1;
            break;
    }
    var visible = $dC2cV.Section.isVisible(section);
    return {
        label: label,
        id: id,
        options: options,
        style: style,
        visible: visible
    };
}
function $213487552e463abb$var$FiltersSection(Props) {
    var section = Props.section;
    var disableAllOpt = Props.disableAll;
    var showLabelOpt = Props.showLabel;
    var canCollapseOpt = Props.canCollapse;
    var maxInRowOpt = Props.maxInRow;
    var borderOpt = Props.border;
    var onChange = Props.onChange;
    var onChecked = Props.onChecked;
    var onUnchecked = Props.onUnchecked;
    var renderAfter = Props.renderAfter;
    var renderIcon = Props.renderIcon;
    var highlightSelectedOptionsOpt = Props.highlightSelectedOptions;
    var autoFocusOpt = Props.autoFocus;
    var largeOpt = Props.large;
    var fullscreenOpt = Props.fullscreen;
    var classNameOpt = Props.className;
    var rtlOpt = Props.rtl;
    var sectionIdPrefixOpt = Props.sectionIdPrefix;
    var disableAll = disableAllOpt !== undefined ? disableAllOpt : false;
    var showLabel = showLabelOpt !== undefined ? showLabelOpt : true;
    var canCollapse = canCollapseOpt !== undefined ? canCollapseOpt : true;
    var maxInRow = maxInRowOpt !== undefined ? maxInRowOpt : 4;
    var border = borderOpt !== undefined ? borderOpt : true;
    var highlightSelectedOptions = highlightSelectedOptionsOpt !== undefined ? highlightSelectedOptionsOpt : false;
    var autoFocus = autoFocusOpt !== undefined ? autoFocusOpt : false;
    var large = largeOpt !== undefined ? largeOpt : false;
    var fullscreen = fullscreenOpt !== undefined ? fullscreenOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var rtl = rtlOpt !== undefined ? rtlOpt : false;
    var sectionIdPrefix = sectionIdPrefixOpt !== undefined ? sectionIdPrefixOpt : "filters";
    var match = $g85JO.useState(function() {
        return true;
    });
    var setExpanded = match[1];
    var expanded = match[0];
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setShowSecondHalf = match$1[1];
    var showSecondHalf = match$1[0];
    var getInitialFocusedCheckbox = function getInitialFocusedCheckbox(param) {
        return $2whNH.getWithDefault($i7mYY.getIndexBy(section.options, function(param) {
            return param.value;
        }), 0);
    };
    var match$2 = $g85JO.useState(function() {
        return getInitialFocusedCheckbox(undefined);
    });
    var setLastFocusedCheckbox = match$2[1];
    var lastFocusedCheckbox = match$2[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setLastFocusedCheckbox, function(prev) {
            if (autoFocus) return prev;
            else return getInitialFocusedCheckbox(undefined);
        });
    }, [
        autoFocus
    ]);
    var options = section.options;
    var selected = $g85JO.useMemo(function() {
        return $i7mYY.keep(options, function(facet) {
            return facet.value;
        }).length;
    }, [
        options
    ]);
    var isRadio = section.style === /* Radio */ 5;
    var isGrid = section.style === /* ButtonCheckbox */ 3 || section.style === /* ColorCheckbox */ 0 || section.style === /* ImageCheckbox */ 2;
    var canCollapse$1 = canCollapse && !isGrid;
    var options$1 = $i7mYY.mapWithIndex(options, function(idx, facet) {
        if (!isRadio) return facet;
        var isLast = function isLast(param) {
            var sliced = $i7mYY.sliceToEnd(options, idx + 1 | 0);
            return $i7mYY.keep(sliced, function(i) {
                return i.value;
            }).length !== 0;
        };
        if (facet.value) return {
            id: facet.id,
            index: facet.index,
            facet: facet.facet,
            label: facet.label,
            swatch: facet.swatch,
            value: !isLast(undefined),
            count: facet.count,
            disabled: facet.disabled
        };
        else return facet;
    });
    var updateValue = function updateValue(index, newValue) {
        var options$2 = isRadio ? $i7mYY.map(options$1, function(facet) {
            return {
                id: facet.id,
                index: facet.index,
                facet: facet.facet,
                label: facet.label,
                swatch: facet.swatch,
                value: false,
                count: facet.count,
                disabled: facet.disabled
            };
        }) : options$1;
        var options$3 = $i7mYY.mapWithIndex(options$2, function(idx, facet) {
            var value = idx === index ? newValue : facet.value;
            return {
                id: facet.id,
                index: facet.index,
                facet: facet.facet,
                label: facet.label,
                swatch: facet.swatch,
                value: value,
                count: facet.count,
                disabled: facet.disabled
            };
        });
        $2whNH.forEach(onChange, function(onChange) {
            $iv6Yc._1(onChange, options$3);
        });
    };
    var onChecked$1 = function onChecked$1(i) {
        $2whNH.forEach(onChecked, function(onChecked) {
            $2whNH.forEach($i7mYY.get(options$1, i), onChecked);
        });
        updateValue(i, true);
    };
    var onUnchecked$1 = function onUnchecked$1(i) {
        $2whNH.forEach(onUnchecked, function(onUnchecked) {
            $2whNH.forEach($i7mYY.get(options$1, i), onUnchecked);
        });
        updateValue(i, false);
    };
    var options$2 = $i7mYY.mapWithIndex(options$1, function(idx, facet) {
        var tmp = {
            id: facet.id,
            index: idx,
            value: facet.value,
            label: facet.label,
            count: facet.count,
            style: section.style,
            isRadio: isRadio,
            isGrid: isGrid,
            onChecked: onChecked$1,
            onUnchecked: onUnchecked$1,
            onFocus: function onFocus(i) {
                $iv6Yc._1(setLastFocusedCheckbox, function(param) {
                    return i;
                });
            },
            disabled: facet.disabled || disableAll,
            highlight: highlightSelectedOptions,
            rtl: rtl,
            autoFocus: idx === lastFocusedCheckbox && autoFocus,
            large: large,
            sectionIdPrefix: sectionIdPrefix,
            key: facet.id
        };
        if (facet.swatch !== undefined) tmp.swatch = facet.swatch;
        var tmp$1 = $2whNH.map(renderIcon, function(fn) {
            return $iv6Yc._1(fn, facet);
        });
        if (tmp$1 !== undefined) tmp.customIcon = $loT9g.valFromOption(tmp$1);
        return /*#__PURE__*/ $g85JO.createElement($021DA.Checkbox.make, tmp);
    });
    var firstHalf = $i7mYY.keepWithIndex(options$2, function(checkbox, idx) {
        if (idx < maxInRow || options$2.length < maxInRow) return true;
        else return !canCollapse$1;
    });
    var secondHalf = $i7mYY.keepWithIndex(options$2, function(checkbox, idx) {
        if (idx >= maxInRow && options$2.length >= maxInRow) return canCollapse$1;
        else return false;
    });
    var match$3 = secondHalf.length;
    var match$4 = match$3 !== 1 ? [
        firstHalf,
        secondHalf
    ] : [
        options$2,
        []
    ];
    var secondHalf$1 = match$4[1];
    var className$1 = $ezf3v.prefix($1TRFX.make([
        isGrid ? "grid" : "flex flex-col",
        expanded ? "h-auto -m-2 p-2" : "h-0 my-0",
        expanded && isGrid ? "-ml-4" : "",
        expanded ? "" : "overflow-hidden"
    ]));
    var match$5 = options$2.length;
    if (match$5 !== 0) return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "filters-section",
        dataSectionId: "" + sectionIdPrefix + "-label",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            "aria-expanded": expanded,
            "aria-labelledby": section.id + "-label",
            className: className,
            id: section.id,
            role: "group"
        }, border ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("border-t border-primary opacity-5")
        }) : null, showLabel ? /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataActive: expanded,
            dataTestId: "filters-collapsible",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                "aria-controls": section.id,
                className: $ezf3v.prefix("flex w-full items-center no-touch-highlight py-4 cursor-pointer"),
                role: "button",
                tabIndex: 0,
                onClick: function onClick(param) {
                    $iv6Yc._1(setExpanded, function(param) {
                        return !expanded;
                    });
                }
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("flex-grow text-lg text-secondary"),
                id: section.id + "-label"
            }, section.label, selected > 0 && !isRadio ? " (" + String(selected) + ")" : null), /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
                clear: true,
                iconSize: /* Smallest */ 4,
                labelSize: /* Smallest */ 4,
                icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {}),
                iconClassName: $ezf3v.prefix((expanded ? "rotate-90" : "-rotate-90") + " scale-105 transform-gpu transition-transform duration-75"),
                className: $ezf3v.prefix("text-accent"),
                tabIndex: -1
            }))
        }) : null, /*#__PURE__*/ $g85JO.createElement("div", {
            "aria-hidden": !expanded,
            className: className$1,
            role: "tabpanel",
            style: {
                gridTemplateColumns: fullscreen ? "repeat(auto-fill, minmax(82px, max-content))" : "repeat(auto-fill, minmax(48px, max-content))"
            }
        }, match$4[0], showSecondHalf ? secondHalf$1 : null, secondHalf$1.length !== 0 && canCollapse$1 ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("mb-4 mt-2")
        }, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataActive: showSecondHalf,
            dataTestId: "filters-show-more-button",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                "aria-label": showSecondHalf ? "see less" : "see " + String(secondHalf$1.length) + " more",
                className: $ezf3v.prefix("inline-block cursor-pointer text-tertiary text-base underline inline-block no-touch-highlight"),
                role: "button",
                onClick: function onClick(param) {
                    $iv6Yc._1(setShowSecondHalf, function(param) {
                        return !showSecondHalf;
                    });
                }
            }, showSecondHalf ? "See Less" : "See More")
        })) : null, $2whNH.getWithDefault(renderAfter, null)))
    });
    else return null;
}
$213487552e463abb$var$FiltersSection.displayName = "FiltersSection";
var $213487552e463abb$export$dd44f18ab656f3bb = $213487552e463abb$var$FiltersSection;
 /* react Not a pure module */ 
});
parcelRegister("021DA", function(module, exports) {

$parcel$export(module.exports, "NumberInput", function () { return $0061752f86849ea3$export$6bf0cd3a219bbade; });
$parcel$export(module.exports, "Checkbox", function () { return $0061752f86849ea3$export$48513f6b9f8ce62d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2Ng4w = parcelRequire("2Ng4w");

var $2whNH = parcelRequire("2whNH");

var $kiuDo = parcelRequire("kiuDo");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $55MCT = parcelRequire("55MCT");

var $bBMv4 = parcelRequire("bBMv4");

var $cVkRC = parcelRequire("cVkRC");

var $6udN8 = parcelRequire("6udN8");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $5av24 = parcelRequire("5av24");
function $0061752f86849ea3$var$FiltersField$NumberInput(Props) {
    var value = Props.value;
    var min = Props.min;
    var max = Props.max;
    var placeholderOpt = Props.placeholder;
    var prefix = Props.prefix;
    var classNameOpt = Props.className;
    var onChange = Props.onChange;
    var placeholder = placeholderOpt !== undefined ? placeholderOpt : "";
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var fromString = function fromString(value$1) {
        try {
            return $kiuDo.float_of_string(value$1 === "" ? "0" : value$1);
        } catch (raw__msg) {
            var _msg = $bBMv4.internalToOCamlException(raw__msg);
            if (_msg.RE_EXN_ID === "Failure") return value;
            throw _msg;
        }
    };
    var match = $g85JO.useState(function() {
        return fromString("");
    });
    var setValue = match[1];
    var value$1 = match[0];
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setFocused = match$1[1];
    var inputRef = $g85JO.useRef(null);
    $g85JO.useEffect(function() {
        $iv6Yc._1(setValue, function(param) {
            return value;
        });
    }, [
        value
    ]);
    var onFocus = function onFocus(param) {
        $iv6Yc._1(setFocused, function(param) {
            return true;
        });
    };
    var onBlur = function onBlur(param) {
        var value$2 = max !== undefined ? min !== undefined ? Math.max(Math.min(value$1, max), min) : Math.min(value$1, max) : min !== undefined ? Math.max(value$1, min) : value$1;
        $iv6Yc._1(setFocused, function(param) {
            return false;
        });
        $iv6Yc._1(setValue, function(param) {
            return value$2;
        });
        $iv6Yc._1(onChange, value$2);
    };
    var onSubmit = function onSubmit(e) {
        e.preventDefault();
        $2whNH.forEach($loT9g.nullable_to_opt(inputRef.current), function(el) {
            el.blur();
        });
    };
    var onInput = function onInput(e) {
        var value = e.target.value;
        $iv6Yc._1(setValue, function(param) {
            return fromString(value);
        });
    };
    var handleFocusInput = function handleFocusInput(param) {
        $2whNH.forEach($loT9g.nullable_to_opt(inputRef.current), function(el) {
            el.focus({
                preventScroll: true
            });
        });
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $1TRFX.make([
            className,
            $ezf3v.prefix("relative"),
            $ezf3v.prefix("rounded-custom ring-accent ring-0 ring-inset focus-within:ring-1"),
            $ezf3v.prefix("cursor-text")
        ]),
        onClick: handleFocusInput
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex w-full")
    }, $2whNH.mapWithDefault(prefix, null, function(prefix) {
        return /*#__PURE__*/ $g85JO.createElement("span", {
            className: $ezf3v.prefix("flex opacity-50 items-center justify-center space-x-2 text-base font-medium text-primary p-2 cursor-text")
        }, prefix);
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-grow")
    }, /*#__PURE__*/ $g85JO.createElement("form", {
        onSubmit: onSubmit
    }, /*#__PURE__*/ $g85JO.createElement("input", {
        ref: $5bEXW.Ref.domRef(inputRef),
        className: $ezf3v.prefix("border-none w-full h-full outline-none text-lg bg-transparent"),
        placeholder: placeholder,
        type: "number",
        value: String(value$1),
        onFocus: onFocus,
        onBlur: onBlur,
        onInput: onInput
    })))), match$1[0] ? null : /*#__PURE__*/ $g85JO.createElement("span", {
        className: $ezf3v.prefix("absolute inset-0 bg-main space-x-2 text-base font-medium text-primary p-2 cursor-text")
    }, $2whNH.mapWithDefault(prefix, null, function(prim) {
        return prim;
    }), " ", value$1));
}
$0061752f86849ea3$var$FiltersField$NumberInput.displayName = "FiltersField.NumberInput";
var $0061752f86849ea3$export$6bf0cd3a219bbade = {
    make: $0061752f86849ea3$var$FiltersField$NumberInput
};
function $0061752f86849ea3$var$FiltersField$Checkbox(Props) {
    var indexOpt = Props.index;
    var value = Props.value;
    var labelOpt = Props.label;
    var countOpt = Props.count;
    var styleOpt = Props.style;
    var swatch = Props.swatch;
    var isRadioOpt = Props.isRadio;
    var isGridOpt = Props.isGrid;
    var onCheckedOpt = Props.onChecked;
    var onUncheckedOpt = Props.onUnchecked;
    var onFocusOpt = Props.onFocus;
    var customIcon = Props.customIcon;
    var disabledOpt = Props.disabled;
    var highlightOpt = Props.highlight;
    var rtlOpt = Props.rtl;
    var autoFocusOpt = Props.autoFocus;
    var largeOpt = Props.large;
    var sectionIdPrefixOpt = Props.sectionIdPrefix;
    var index = indexOpt !== undefined ? indexOpt : 0;
    var label = labelOpt !== undefined ? labelOpt : "";
    var count = countOpt !== undefined ? countOpt : 0;
    var style = styleOpt !== undefined ? styleOpt : /* Checkbox */ 1;
    var isRadio = isRadioOpt !== undefined ? isRadioOpt : false;
    var isGrid = isGridOpt !== undefined ? isGridOpt : false;
    var onChecked = onCheckedOpt !== undefined ? onCheckedOpt : function onChecked(i) {};
    var onUnchecked = onUncheckedOpt !== undefined ? onUncheckedOpt : function onUnchecked(i) {};
    var onFocus = onFocusOpt !== undefined ? onFocusOpt : function onFocus(i) {};
    var disabled = disabledOpt !== undefined ? disabledOpt : false;
    var highlight = highlightOpt !== undefined ? highlightOpt : false;
    var rtl = rtlOpt !== undefined ? rtlOpt : false;
    var autoFocus = autoFocusOpt !== undefined ? autoFocusOpt : false;
    var large = largeOpt !== undefined ? largeOpt : false;
    var sectionIdPrefix = sectionIdPrefixOpt !== undefined ? sectionIdPrefixOpt : "filters";
    var bg = value ? "bg-accent text-main" : "bg-transparent hover:text-primary text-secondary";
    var isButton = style === /* ButtonCheckbox */ 3;
    var isSwatch = (style === /* ColorCheckbox */ 0 || style === /* ImageCheckbox */ 2) && $2whNH.isSome(swatch);
    var interactivity = disabled ? "pointer-events-none opacity-25" : "cursor-pointer";
    var border = value ? isSwatch ? "ring-2 ring-current text-accent" : "border border-solid border-accent" : "border border-solid hover:border-primary border-secondary";
    var renderSwatchBackground = function renderSwatchBackground(param) {
        var className = $ezf3v.prefix("absolute inset-0");
        var bg;
        if (style >= 3) bg = null;
        else switch(style){
            case /* ColorCheckbox */ 0:
                bg = swatch !== undefined ? /*#__PURE__*/ $g85JO.createElement("div", {
                    className: className,
                    style: {
                        background: swatch
                    }
                }) : null;
                break;
            case /* Checkbox */ 1:
                bg = null;
                break;
            case /* ImageCheckbox */ 2:
                bg = swatch !== undefined ? /*#__PURE__*/ $g85JO.createElement("div", {
                    className: className
                }, /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
                    src: swatch,
                    fit: /* Contain */ 2,
                    alt: label,
                    priority: 1
                })) : null;
                break;
        }
        return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, bg, value ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex w-full h-full items-center justify-center")
        }, /*#__PURE__*/ $g85JO.createElement($cVkRC.make, {
            className: $ezf3v.prefix($1TRFX.make([
                "text-white",
                "drop-shadow-dark filter"
            ])),
            strokeWidth: "3"
        })) : null);
    };
    var fill;
    switch(style){
        case /* Checkbox */ 1:
            fill = value ? /*#__PURE__*/ $g85JO.createElement($cVkRC.make, {
                className: $ezf3v.prefix("text-main w-7 h-7 absolute inset-0 transform scale-50 -translate-y-px -translate-x-px"),
                strokeWidth: "3"
            }) : null;
            break;
        case /* ColorCheckbox */ 0:
        case /* ImageCheckbox */ 2:
            fill = renderSwatchBackground(undefined);
            break;
        case /* ButtonCheckbox */ 3:
        case /* Range */ 4:
            fill = null;
            break;
        case /* Radio */ 5:
            fill = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "absolute inset-0 bg-main m-1 rounded-full transform transition-transform duration-75",
                    value ? "scale-70" : "scale-0"
                ]))
            });
            break;
    }
    var rounded;
    switch(style){
        case /* Checkbox */ 1:
        case /* ButtonCheckbox */ 3:
        case /* Range */ 4:
            rounded = "rounded-custom";
            break;
        case /* ColorCheckbox */ 0:
        case /* ImageCheckbox */ 2:
        case /* Radio */ 5:
            rounded = "rounded-full";
            break;
    }
    var textAlign = style !== 1 && style < 4 ? "text-center" : "";
    var labelContainerWidth = style !== 1 && style < 3 ? "w-full px-2" : "";
    var padding = style !== 3 ? large ? "p-4" : "py-2" : large ? "py-4 px-6" : "py-3 px-4";
    var icon;
    var exit = 0;
    if (customIcon !== undefined) icon = $loT9g.valFromOption(customIcon);
    else switch(style){
        case /* ColorCheckbox */ 0:
        case /* ImageCheckbox */ 2:
            exit = 2;
            break;
        case /* ButtonCheckbox */ 3:
            icon = null;
            break;
        case /* Checkbox */ 1:
        case /* Range */ 4:
        case /* Radio */ 5:
            exit = 1;
            break;
    }
    switch(exit){
        case 1:
            icon = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "w-7 h-7 relative flex-shrink-0",
                    "overflow-hidden",
                    border,
                    rounded,
                    bg
                ]))
            }, fill);
            break;
        case 2:
            icon = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "w-10 h-10 relative flex-shrink-0",
                    "overflow-hidden",
                    border,
                    rounded,
                    bg
                ]))
            }, fill);
            break;
    }
    var tooltipText = style !== 1 && style < 3 ? "" + label + " have " + String(count) + " products" : undefined;
    var countElement = count !== 0 && style !== /* ImageCheckbox */ 2 && style !== /* ColorCheckbox */ 0 ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("opacity-50 inline")
    }, " (" + String(count) + ")") : null;
    var labelElement = /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, label, countElement);
    var onClick = function onClick(param) {
        if (!disabled) {
            if (!value || isRadio) return $iv6Yc._1(onChecked, index);
            else return $iv6Yc._1(onUnchecked, index);
        }
    };
    var ref = $g85JO.useRef(null);
    var domRef = autoFocus ? $loT9g.some($5bEXW.Ref.domRef(ref)) : undefined;
    $6udN8.use($2Ng4w.string_of_bool(autoFocus), ref);
    var onFocus$1 = function onFocus$1(param) {
        $iv6Yc._1(onFocus, index);
    };
    var tmp = {
        className: $ezf3v.prefix($1TRFX.make([
            "flex items-center no-touch-highlight relative",
            "group-3",
            isGrid && isSwatch ? "mb-4" : isGrid ? "mb-4 mr-4" : "",
            isSwatch ? "flex-col" : rtl ? "flex-row-reverse space-x-reverse" : "",
            isButton ? border : "",
            isButton ? rounded : "",
            isButton ? bg : "hover:text-primary text-secondary",
            padding,
            interactivity
        ])),
        role: style >= 5 ? "menuitemradio" : "menuitemcheckbox",
        tabIndex: 0,
        onFocus: onFocus$1,
        onClick: onClick
    };
    if (domRef !== undefined) tmp.ref = $loT9g.valFromOption(domRef);
    if (tooltipText !== undefined) tmp.title = $loT9g.valFromOption(tooltipText);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataDisabled: disabled,
        dataActive: value,
        dataTestId: "filters-option",
        dataId: "" + sectionIdPrefix + "-" + label + "",
        ariaChecked: value,
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, highlight && !isButton ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "absolute -left-6 -right-6 top-0 bottom-0 pointer-events-none",
                value ? "opacity-10 bg-accent" : "group-3-hover:bg-primary opacity-5"
            ]))
        }) : null, icon, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "relative",
                "flex-grow text-lg",
                isSwatch ? "mt-3" : rtl ? "" : "ml-3",
                textAlign,
                labelContainerWidth,
                "font-button"
            ]))
        }, style === 4 || style === 3 ? labelElement : /*#__PURE__*/ $g85JO.createElement($5av24.make, {
            lines: 2,
            children: labelElement
        })))
    });
}
$0061752f86849ea3$var$FiltersField$Checkbox.displayName = "FiltersField.Checkbox";
var $0061752f86849ea3$export$48513f6b9f8ce62d = {
    make: $0061752f86849ea3$var$FiltersField$Checkbox
};
 /* react Not a pure module */ 
});


})();
//# sourceMappingURL=ListPageContent.bs.3f28c839.js.map
